/**
 * 前端字段解密工具
 * 对应后端: AES-CBC / PKCS5Padding / KEY="lscpcEnc2026Data" / IV="lscpcDataIv2608!"
 * 密文格式: "enc:" + Base64(AES加密结果)
 *
 * 依赖: crypto-js (npm install crypto-js)
 */
import CryptoJS from "crypto-js";

const PREFIX = "enc:";

const _k0 = [108, 115, 99, 112, 99];
const _k1 = [69, 110, 99, 50, 48, 50, 54];
const _k2 = [68, 97, 116, 97];
const _i0 = [108, 115, 99, 112, 99];
const _i1 = [68, 97, 116, 97, 73, 118];
const _i2 = [50, 54, 48, 56, 33];

function _r(a) {
  return a
    .map(function(c) {
      return String.fromCharCode(c);
    })
    .join("");
}

var AES_KEY = CryptoJS.enc.Utf8.parse(_r(_k0) + _r(_k1) + _r(_k2));
var AES_IV = CryptoJS.enc.Utf8.parse(_r(_i0) + _r(_i1) + _r(_i2));

/**
 * 解密单个字段值
 * @param {string} value - 密文字段值，如 "enc:U2FsdGVk..."
 * @returns {string} 解密后的明文，非密文原样返回
 */
export function decryptField(value) {
  if (!value || typeof value !== "string" || value.indexOf(PREFIX) !== 0) {
    return value;
  }
  try {
    var base64Str = value.slice(PREFIX.length);
    var decrypted = CryptoJS.AES.decrypt(base64Str, AES_KEY, {
      iv: AES_IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8) || value;
  } catch (e) {
    return value;
  }
}

/**
 * 后端加密的字段列表（与 NoticeServiceImpl 保持一致）
 */
var ENCRYPT_FIELDS = [
  "noticeId",
  "schemeId",
  "schemeCode",
  "schemeName",
  "noticeTitle",
  "matBigClassesNameStr",
  "mergePurchaseTypeName",
  "provinceName",
  "purchaseTypeName",
  "schemeClassName",
  "noticeDetailsUrl",
  "opUnitName"
];

/**
 * 解密一整行数据的所有加密字段
 * @param {Object} row - 一行密文数据
 * @returns {Object} 所有加密字段解密后的新对象
 */
export function decryptRow(row) {
  var result = {};
  var keys = Object.keys(row);
  for (var i = 0; i < keys.length; i++) {
    result[keys[i]] = row[keys[i]];
  }
  for (var j = 0; j < ENCRYPT_FIELDS.length; j++) {
    var field = ENCRYPT_FIELDS[j];
    var val = result[field];
    if (val && typeof val === "string" && val.indexOf(PREFIX) === 0) {
      result[field] = decryptField(val);
    }
  }
  return result;
}

/**
 * 批量解密多行数据
 * @param {Array<Object>} rows - 多行密文数据
 * @returns {Array<Object>} 所有行解密后的数组
 */
export function decryptRows(rows) {
  if (!rows || rows.length === 0) {
    return [];
  }
  return rows.map(function(row) {
    return decryptRow(row);
  });
}
